<template>
    <el-row class="content">
        <el-col :span="24" style="height:calc( 100% - 5px );overflow: auto;background:#fff;">
            <div id="attendFenceCon" style="position: relative;padding: 0;height: 100%;width: 100%;display: flex;">
                <div class="list">
                    <ul :class="'area'+index" v-for="(item, index) in allPoint" :key="index">
                        <p class="ptitle">{{'第 ' + (index + 1) + ' 区域'}}<button class="layui-btn layui-btn-xs delBtn layui-btn-danger" @click="delBtnFun(index)"><i class="el-icon-delete"></i></button></p>
                        <li v-for="(child, i) in item" :key="i">
                            <div style="text-align: left;">
                                <span>{{i+1}}</span>
                                <p>经度：<input v-model="child.lng" readOnly /></p>
                                <p>纬度：<input v-model="child.lat" readOnly /></p>
                            </div>
                        </li>
                    </ul>
                    <ul :class="'area'+allPoint.length+1">
                        <p class="ptitle">{{'第 ' + (allPoint.length + 1) + ' 区域'}}</p>
                        <li v-for="(child, i) in currentPonit" :key="i">
                            <div style="text-align: left;">
                                <span>{{i+1}}</span>
                                <p>经度：<input v-model="child.lng" readOnly /></p>
                                <p>纬度：<input v-model="child.lat" readOnly /></p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="mapContent">
                    <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:100%;width:100%;" @click="getClickInfo" :scroll-wheel-zoom='true'></baidu-map>
                    <div class="mapBtn">
                        <button class="mapClear layui-btn layui-btn-danger" style="backgroundColor:#FD774B;" @click="mapClearAll">清空</button>
                        <button class="mapSub layui-btn layui-btn-normal" @click="mapSaveFun" style="backgroundColor:#4AA2DE">保存</button>
                        <button class="mapAdd layui-btn" @click="mapAddFun" style="backgroundColor:#4AA2DE;margin-right:10px" >新增</button>
                        <button class="mapClearCur layui-btn layui-btn-warm" style="backgroundColor: #FFB800"   @click="mapClearCur">清除当前区域</button>
                    </div>
                    <div class="mapSearch">
                        <input type="text" v-model="searchInput" id="searchCon" style="width:300px;height:40px;margin:0;" />
                        <button class="layui-btn layui-btn-normal" @click="btnSearchFun" style="height:38px;top: -2px;position: relative;margin-left:10px;background:#43ADFC">查询</button>
                    </div>
                </div>
            </div>
        </el-col>
    </el-row>
</template>
<script>
import myHttp from "../../../untils/port.js";
import util from "../../../untils/util.js"
import base from '../../../untils/base'
export default {
    data(){
        return{
            projectId:'',
            currentPonit:[],//当前区域的经纬度
            allPoint:[], //所有区域的经纬度
            curClass:'ul.area0', //当前区域
            center: {lng: 117.283334, lat: 31.866339},
            zoom: 13,
            map:{},
            geoc:{},
            searchInput:'',
            local:'',//本地地图查询
        }
    },
    mounted(){
        this.projectId = this.$store.state.groupId;
        // this.getData();
    },
    methods:{
        //清空
        mapClearAll(){
            this.map.clearOverlays();
            this.allPoint = [];
            this.currentPonit = [];
        },
        //保存
        mapSaveFun(){
            if (this.currentPonit.length > 0) {
                var li = this.currentPonit;
                this.allPoint.push(li);
            }
            var userId = this.$store.state.user.id;
            myHttp.updateProject({
                id: this.projectId,
                userId:userId,
                enclosure: JSON.stringify(this.allPoint)
            }).then(function (resp) {
                if (resp.code == '200') {
                    //layer.msg("保存成功", { icon: 1 });
                } else {
                    //layer.msg(resp.msg, { icon: 5 });
                }
            }, function (error) {
            });
        },
        //新增
        mapAddFun(){
            if (this.currentPonit.length < 3) {
                this.$message.error('请将当前区域添加完成（最少3个标记）！')
                // layer.msg("请将当前区域添加完成（最少3个标记）！", { icon: 5 });
            } else {
                if (this.currentPonit.length > 0) {
                    var obj = this.currentPonit;
                    this.allPoint.push(obj);
                }
                this.currentPonit = [];
            }
        },
        //清除当前区域
        mapClearCur(){
            this.currentPonit = [];
            this.map.clearOverlays();
            if (this.allPoint.length > 0) {
                for (var i = 0; i < this.allPoint.length; i++) {
                    var oldList = this.allPoint[i];
                    var list = [];
                    for (var j = 0; j < oldList.length; j++) {
                        // 创建标注
                        var marker = new BMap.Marker(oldList[j]);
                        // 将标注添加到地图中
                        this.map.addOverlay(marker);
                        list.push(new BMap.Point(oldList[j].lng, oldList[j].lat));
                    }
                    var polygonList = new BMap.Polygon(list, {
                        strokeColor: "blue",
                        strokeWeight: 2,
                        strokeOpacity: 0.5,
                        strokeStyle: 'dashed',
                        fillOpacity: 0.3
                    });  //创建多边形
                    this.map.addOverlay(polygonList);
                }
            }
        },
        //获取数据
        getData(){
            var that = this;
            myHttp.getProjectById({
                id: this.projectId
            }).then(function (resp) {
                if (resp.data.code == '200') {
                    var data = resp.data.data.project;
                    if(data.gpsPoint && data.gpsPoint!=''){
                        var p = data.gpsPoint.split(',')
                        that.center = {
                            lng:p[0],
                            lat:p[1]
                        }
                    }
                    that.showFenceArea(data.enclosure);
                } else {
                    that.$message.error(resp.data.msg);
                }
            }, function (error) {
            });
        },
        //展示电子围栏
        showFenceArea(mapArea){
            if (mapArea != undefined && mapArea != ""){
                this.allPoint = JSON.parse(mapArea);
                if (this.allPoint.length > 0 && this.allPoint[0].length > 0) {
                    this.center.lng = this.allPoint[0][0].lng;
                    this.center.lat = this.allPoint[0][0].lat;
                }
                for (var j = 0; j < this.allPoint.length; j++) {
                    this.currentPonit = this.allPoint[j];
                    var list = [];
                    for (var i = 0; i < this.currentPonit.length; i++) {
                        list.push(new BMap.Point(this.currentPonit[i].lng, this.currentPonit[i].lat));
                        var point = new BMap.Point(this.currentPonit[i].lng, this.currentPonit[i].lat);
                        // pointList.push(point);
                        var marker = new BMap.Marker(point);
                        var index = i + 1;
                        var label = new BMap.Label(index, {
                            offset: new BMap.Size(5, 4)
                        });
                        label.setStyle({
                            background: 'none', color: '#fff', border: 'none'//只要对label样式进行设置就可达到在标注图标上显示数字的效果
                        });
                        marker.setLabel(label);//显示地理名称
                        this.map.addOverlay(marker);
                        this.markerHandleFun(marker);
                    }
                    var polygonList = new BMap.Polygon(list, {
                        strokeColor: "blue",
                        strokeWeight: 2,
                        strokeOpacity: 0.5,
                        strokeStyle: 'dashed',
                        fillOpacity: 0.3
                    });  //创建多边形
                    this.map.addOverlay(polygonList);
                }
                this.currentPonit = []
            }
        },
        //地图展示
        handler ({BMap, map}) {
            this.map = map;
            this.geoc = new BMap.Geocoder();
            this.local = new BMap.LocalSearch(map, {
                renderOptions: { map: map }
            });
            this.getData();
            // var point = new BMap.Point(this.center.lng, this.center.lat)
            // map.centerAndZoom(point, 13)
            // var marker = new BMap.Marker(point) // 创建标注
            // map.addOverlay(marker) // 将标注添加到地图中
            // var circle = new BMap.Circle(point, 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
            // map.addOverlay(circle)
        },
        //地图点击方法
        getClickInfo (e) {
            // this.map.clearOverlays();
            this.currentPonit.push(e.point);
            var point = new BMap.Point(e.point.lng, e.point.lat);
            // 创建标注  
            var marker = new BMap.Marker(point);
            // 将标注添加到地图中
            this.map.addOverlay(marker);
            if(this.currentPonit.length>=3){
                this.clearPolygon();
                var list = [];
                for(var i=0;i<this.currentPonit.length;i++){
                    list.push(new BMap.Point(this.currentPonit[i].lng,this.currentPonit[i].lat));
                }
                var polygonList = new BMap.Polygon(list, {strokeColor:"blue", strokeWeight:2, strokeOpacity:0.5,strokeStyle: 'dashed',fillOpacity: 0.3});  //创建多边形
                this.map.addOverlay(polygonList);
                if(this.allPoint.length>0){
                    for(var i=0;i<this.allPoint.length;i++){
                        var oldList = this.allPoint[i];
                        list = [];
                        for(var j=0;j<oldList.length;j++){
                            list.push(new BMap.Point(oldList[j].lng,oldList[j].lat));
                        }
                        var polygonList = new BMap.Polygon(list, {strokeColor:"blue", strokeWeight:2, strokeOpacity:0.5,strokeStyle: 'dashed',fillOpacity: 0.3});  //创建多边形
                        this.map.addOverlay(polygonList);
                    }
                }
            }
        },
        //设置地图坐标和中点
        setCenterMap(obj){
            var point = new BMap.Point(this.center.lng, this.center.lat);
            this.map.centerAndZoom(point, 12)
            var marker = new BMap.Marker(point)
            this.map.addOverlay(marker)
        },
        //点击查询
        btnSearchFun(){
            this.local.search(this.searchInput);
        },
        //标记点操作（拖拽）
        markerHandleFun(marker) {
            //标记编辑
            marker.enableDragging();
            //标注拖拽后的位置
            marker.addEventListener("dragend", function (e) {
                var curPointFlag = false;//判断拖拽的标注是否已经在allPoint中找到
                if (this.allPoint.length > 0) {
                    for (var i = 0; i < this.allPoint.length; i++) {
                        for (var j = 0; j < this.allPoint[i].length; j++) {
                            if (this.allPoint[i][j].lng == e.currentTarget.LA.lng && this.allPoint[i][j].lat == e.currentTarget.LA.lat) {
                                curPointFlag = true;
                                this.allPoint[i][j].lng = e.point.lng;
                                this.allPoint[i][j].lat = e.point.lat;
                            }
                        }
                    }
                }
                if (!curPointFlag && this.currentPonit.length > 0) {
                    for (var k = 0; k < this.currentPonit.length; k++) {
                        if (this.currentPonit[k].lng == e.currentTarget.LA.lng && this.currentPonit[k].lat == e.currentTarget.LA.lat) {
                            this.currentPonit[k].lng = e.point.lng;
                            this.currentPonit[k].lat = e.point.lat;
                        }
                    }
                }
                this.repaint();//重绘
            });
        },
        //重绘放弃区域
        repaint() {
            this.clearPolygon();
            var list = [];
            if (this.currentPonit.length >= 3) {
                for (var i = 0; i < this.currentPonit.length; i++) {
                    list.push(new BMap.Point(this.currentPonit[i].lng, this.currentPonit[i].lat));
                }
                var polygonList = new BMap.Polygon(list, {
                    strokeColor: "blue",
                    strokeWeight: 2,
                    strokeOpacity: 0.5,
                    strokeStyle: 'dashed',
                    fillOpacity: 0.3
                });  //创建多边形
                map.addOverlay(polygonList);
            }
            if (this.allPoint.length > 0) {
                for (var i = 0; i < this.allPoint.length; i++) {
                    var oldList = this.allPoint[i];
                    list = [];
                    for (var j = 0; j < oldList.length; j++) {
                        list.push(new BMap.Point(oldList[j].lng, oldList[j].lat));
                    }
                    var polygonList = new BMap.Polygon(list, {
                        strokeColor: "blue",
                        strokeWeight: 2,
                        strokeOpacity: 0.5,
                        strokeStyle: 'dashed',
                        fillOpacity: 0.3
                    });  //创建多边形
                    map.addOverlay(polygonList);
                }
            }
        },
        //删除区域面(点与点的连接面)
        clearPolygon() {
            var allOverlay = this.map.getOverlays();
            for (var i = 0; i < allOverlay.length; i++) {
                if (allOverlay[i].toString() == "[object Polygon]") {
                    this.map.removeOverlay(allOverlay[i]);
                }
            }
        },
        //删除某一区域
        delBtnFun(index){
            this.map.clearOverlays();
            var list = this.allPoint.splice(index, 1);
            this.showFenceArea(JSON.stringify(this.allPoint));
            var points = [];
            if (this.currentPonit.length > 0) {
                for (var i = 0; i < this.currentPonit.length; i++) {
                    points.push(new BMap.Point(this.currentPonit[i].lng, this.currentPonit[i].lat));
                    var point = new BMap.Point(this.currentPonit[i].lng, this.currentPonit[i].lat);
                    var marker = new BMap.Marker(point);
                    var index = i + 1;
                    var label = new BMap.Label(index, {
                        offset: new BMap.Size(5, 4)
                    });
                    label.setStyle({
                        background: 'none', color: '#fff', border: 'none'//只要对label样式进行设置就可达到在标注图标上显示数字的效果
                    });
                    marker.setLabel(label);//显示地理名称 a 
                    this.map.addOverlay(marker);
                    this.markerHandleFun(marker);
                }
                if (points.length >= 3) {
                    var polygonList = new BMap.Polygon(points, {
                        strokeColor: "blue",
                        strokeWeight: 2,
                        strokeOpacity: 0.5,
                        strokeStyle: 'dashed',
                        fillOpacity: 0.3
                    });  //创建多边形
                    this.map.addOverlay(polygonList);
                }
            }
        },
    }
}
</script>
<style scoped>
    .content{
        width: 100%;
        height: 100%;
        padding: 10px;
    }
    .list li {
        border-bottom: 1px solid #ddd;
        padding: 5px;
        list-style: none;
    }
    .list li p {
        margin: 10px 0;
        display: flex;
        align-items: center;
    }
    .list li p input,.list li .el-input {
        display: inline-block;
        width: 120px;
        height: 30px;
        margin: 0;
    }
    .list li .el-input input{
        height: 30px;
    }
    .list li span {
        width: 30px;
        border-radius: 15px;
        height: 30px;
        text-align: center;
        background: #69c2fb;
        display: inline-block;
        font-size: 14px;
        line-height: 30px;
        color: #fff;
    }
    .mapBtn {
        z-index: 100;
        position: absolute;
        top: 5px;
        left: 5px;
        display: inline-block;
    }
    .mapBtn>button,.mapSearch>button{
    border: 0;
    outline: 0;
    padding: 10px;
    color:#fff
    }
    .mapSearch {
        z-index: 100;
        position: absolute;
        top: 5px;
        right: 5px;
        display: inline-block;
    }
    .mapClear,
    .mapSub {
        margin-right: 10px;
    }
    .delBtn {
        float: right;
        position: relative;
        right: 10px;
    }
    .list {
        width: 240px;
        height: calc(100% - 10px);
        overflow: auto;
        border-right: 1px solid #ddd;
        display: inline-block;
    }
    #allmap {
        width: 100%;
        height: 100%;
        margin: 0;
    }
    .anchorBL {
        display: none;
    }
    #allmap img {
        max-width: inherit;
    }
    .mapContent {
        width: calc(100% - 260px);
        height: calc(100% - 10px);
        position: relative;
        display: inline-block;
    }
    .list ul {
        margin: 0;
        padding: 0;
    }
    .list .ptitle {
        border-bottom: 1px solid #ddd;
        margin: 0;
        text-align: center;
        padding: 5px 0;
    }
    .selectInline {
        float: left;
        text-align: left;
        color: rgba(0, 0, 0, 1);
        opacity: 1;
    }
</style>